import { render, staticRenderFns } from "./ShippingIncoherenceBanner.vue?vue&type=template&id=37c1c97f"
import script from "./ShippingIncoherenceBanner.vue?vue&type=script&lang=js"
export * from "./ShippingIncoherenceBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports